import { render, staticRenderFns } from "./ActivateForRentStatusComponent.vue?vue&type=template&id=70545e96"
import script from "./ActivateForRentStatusComponent.vue?vue&type=script&lang=js"
export * from "./ActivateForRentStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports